module.exports = __webpack_public_path__ + "static/media/vertigo.8ced9337.jpg";